import { render, staticRenderFns } from "./PostOperative.vue?vue&type=template&id=4a6edcf8&scoped=true&"
import script from "./PostOperative.vue?vue&type=script&lang=js&"
export * from "./PostOperative.vue?vue&type=script&lang=js&"
import style0 from "./PostOperative.vue?vue&type=style&index=0&id=4a6edcf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6edcf8",
  null
  
)

export default component.exports